module.exports = __webpack_public_path__ + "media/images/favicon/bg-guide-f664c2f7efae2e71789e2e8506467d50.svg";